import { render, staticRenderFns } from "./bizVehicle.vue?vue&type=template&id=4254b334&scoped=true&"
import script from "./bizVehicle.vue?vue&type=script&lang=js&"
export * from "./bizVehicle.vue?vue&type=script&lang=js&"
import style0 from "./bizVehicle.vue?vue&type=style&index=0&id=4254b334&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4254b334",
  null
  
)

export default component.exports